import { RouterChild } from '@/router';

export default [
  { name: 'accounting-overview', path: 'accounting/overview', component: () => import('./views/Overview.vue') } as RouterChild
];
